import { useCallback } from 'react';
import {
  EmptyView as UIKitEmptyView,
  Flex,
  IconEmptyFast,
  IconEmptyZzim,
  PrimaryButton,
} from '@banhala/ui-kit';
import { useNavigator } from 'shared/src/utils';
import { useOpenDeeplink } from 'shared/src/hooks';
import { useConfigs } from 'shared/src/queries';
import { useLogClickTodayDelivery } from '../hooks/useLogClickTodayDelivery';

type Props = {
  isDeliveryFilterOn: boolean;
};

export const EmptyView = ({ isDeliveryFilterOn }: Props) => {
  const { navigator } = useNavigator();
  const { data: configs } = useConfigs();
  const { openDeeplink } = useOpenDeeplink();
  const logClickTodayDelivery = useLogClickTodayDelivery();

  const handlePressTodayDelivery = useCallback(() => {
    logClickTodayDelivery();
    openDeeplink(configs.today_delivery.department_deeplink);
  }, [configs, logClickTodayDelivery, openDeeplink]);

  if (isDeliveryFilterOn) {
    return (
      <Flex.Center flex={1} padding={{ vertical: 80, horizontal: 12 }} gap={24}>
        <UIKitEmptyView
          title={'오늘출발 상품이 없어요'}
          icon={<IconEmptyFast />}
        />
        <Flex width={256}>
          <PrimaryButton
            color={'pink'}
            size={'large'}
            variant={'fill'}
            onPress={handlePressTodayDelivery}
          >
            오늘출발 보러가기
          </PrimaryButton>
        </Flex>
      </Flex.Center>
    );
  }

  return (
    <Flex.Center flex={1} padding={{ vertical: 80, horizontal: 12 }} gap={24}>
      <UIKitEmptyView
        title={'찜한 상품이 없어요'}
        description={'에이블리의 인기 상품을 보러갈까요?'}
        icon={<IconEmptyZzim />}
      />
      <Flex width={256}>
        <PrimaryButton
          color={'gray'}
          size={'large'}
          variant={'fill'}
          onPress={() => navigator.moveToRankingGoods()}
        >
          랭킹 상품 보러가기
        </PrimaryButton>
      </Flex>
    </Flex.Center>
  );
};
